var styles = {"fontElementMap":"aGZKM","orderedlist":"yBD6p","bulletedlist":"JJYiS","listItem":"pQwrz"};

export { styles as s };
//# sourceMappingURL=lists-9e22ddd9.js.map
